// Less worked copypaste of https://github.com/facebook/dataloader

const Promise = require('bluebird')

class DebounceQueue {
    constructor (loader, idFn = null, timeout = 1, shouldCache = true) {
        this._queue = []
        this._promiseQueue = {}
        this._shouldCache = shouldCache
        this._cache = {}
        this._loader = loader
        this._idFn = idFn || ((item) => item.id)
        this._timeout = timeout
        this._accepted = ['string', 'number']
        this._timeoutHandle = null
        this._running = false
    }

    isQueued (id) {
        return this._queue.find(_ => _.id === id)
    }

    load (id) {
        if ( !id ) {
            return new Promise(resolve => {
                resolve(null)
            })
        }
        if (this._accepted.indexOf(typeof id) === -1 ) {
            throw new Error(`ID must be String or Number, ${id} given`)
        }

        const cleanId = String(id)

        if (this._shouldCache && this._cache.hasOwnProperty(cleanId)) {
            return Promise.resolve(this._cache[cleanId])
        }

        if (this._promiseQueue.hasOwnProperty(cleanId)) {
            return this._promiseQueue[cleanId]
        }

        const promise = new Promise((resolve, reject) => {
            this._queue.push({
                id: cleanId,
                resolve,
                reject
            })

            this.tick()
        })

        this._promiseQueue[cleanId] = promise

        return promise
    }

    tick () {
        if (this._timeoutHandle) {
            clearTimeout(this._timeoutHandle)
        }

        this._timeoutHandle = setTimeout(() => {
            this.consume()
        }, this._timeout)
    }

    consume () {
        if (this._running) {
            return
        }

        if (this._queue.length < 1) {
            return
        }

        this._running = true

        const queue = this._queue
        this._queue = []

        const ids = queue.map(_ => _.id)

        this._loader(ids).then((result) => {
            const referenced = result.reduce((a, b) => {
                const id = this._idFn(b)
                a[String(id)] = b
                return a
            }, {})

            this._cache = Object.assign(this._cache, referenced)

            queue.forEach((item) => {
                if (this._cache.hasOwnProperty(item.id)) {
                    item.resolve(this._cache[item.id])
                } else {
                    item.reject(new Error(`Not found ${item.id}`))
                }

                if (this._promiseQueue.hasOwnProperty(item.id)) {
                    delete this._promiseQueue[item.id]
                }
            })

            this._running = false
            this.tick()
        })
    }
}

module.exports = DebounceQueue



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/debounce-queue.js